import { isSameOrigin } from "./isSameOrigin";
import { isValidUrl } from "./validators";
import { removeTrailingSlash } from "./formatters";

// Redirecting to these is either a no-op (you'd land here anyway) or a loop
// risk (bouncing straight back to the login page itself).
const DEFAULT_BLOCKED_PATHNAMES = ["/", "/login"];

export const getSafeRedirectTarget = (
  redirect: string | null | undefined,
  blockedPathnames: string[] = DEFAULT_BLOCKED_PATHNAMES,
): string | null => {
  if (!redirect) return null;
  if (!isValidUrl(redirect)) return null;
  if (!isSameOrigin(redirect)) return null;

  const url = new URL(redirect);
  if (url.protocol !== "http:" && url.protocol !== "https:") return null;

  // pathname keeps percent-escapes as-is (e.g. "/%6c%6f%67%69%6e"), but the
  // browser decodes them on navigation — decode here too so an encoded
  // blocked path can't slip past this check.
  let decodedPathname: string;
  try {
    decodedPathname = decodeURIComponent(url.pathname);
  } catch {
    decodedPathname = url.pathname;
  }

  const normalizedPathname = (
    removeTrailingSlash(decodedPathname) || "/"
  ).toLowerCase();
  if (blockedPathnames.includes(normalizedPathname)) return null;

  return redirect;
};
